import React, { useMemo } from "react";
import { baselineMinutes } from "../../ai/analytics/prediction";

export default function PerformanceDashboard({ logs, stepLabel }) {
  const grouped = useMemo(() => {
    const map = {};
    (logs || []).forEach(L => {
      const pt = L.productType || "Mug";
      const step = L.step || "unknown";
      const k = `${pt}|${step}`;
      const actual = Number(L.minutes) || 0;
      const pred = baselineMinutes(pt, step)?.minutes ?? 5;
      map[k] = map[k] || { productType: pt, step, sumActual: 0, count: 0, pred };
      map[k].sumActual += actual; map[k].count += 1;
    });
    return Object.values(map).map(v => ({
      productType: v.productType, step: v.step, avgActual: v.sumActual / v.count, predicted: v.pred, count: v.count, diff: (v.sumActual / v.count) - v.pred
    })).sort((a,b)=> Math.abs(b.diff) - Math.abs(a.diff));
  }, [logs]);

  const score = useMemo(() => {
    if (!grouped.length) return 0;
    const mae = grouped.reduce((a,g) => a + Math.abs(g.diff), 0) / grouped.length;
    const norm = 1 / (1 + mae/10);
    return Math.round(norm * 100);
  }, [grouped]);

  return (
    <div className="space-y-4">
      <div className="rounded-2xl border p-3 flex items-center justify-between">
        <div>
          <div className="font-semibold">Prediction Accuracy</div>
          <div className="text-sm opacity-70">How close are baseline predictions to actuals (higher is better)</div>
        </div>
        <div className="text-2xl font-bold">{score}%</div>
      </div>

      <div className="rounded-2xl border p-3">
        <div className="font-semibold mb-2">Largest Gaps (by Product Type & Step)</div>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-50"><tr><Th>Product</Th><Th>Step</Th><Th className="text-right">Pred (min)</Th><Th className="text-right">Actual avg (min)</Th><Th className="text-right">Diff</Th><Th className="text-right">Sessions</Th></tr></thead>
            <tbody>
              {grouped.length===0 && <tr><td colSpan={6} className="p-3 text-center opacity-70">No data yet.</td></tr>}
              {grouped.map((g,i)=>(
                <tr key={i} className="border-t">
                  <Td>{g.productType}</Td><Td>{stepLabel(g.step)}</Td>
                  <Td className="text-right">{g.predicted.toFixed(1)}</Td>
                  <Td className="text-right">{g.avgActual.toFixed(1)}</Td>
                  <Td className={`text-right ${g.diff>0?"text-red-600":"text-emerald-700"}`}>{(g.diff>0?"+":"")+g.diff.toFixed(1)}</Td>
                  <Td className="text-right">{g.count}</Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-xs opacity-70 mt-2">Tip: If actuals are consistently lower/higher, update your rules or let Mudo auto‑tune them from Time Logs.</div>
      </div>
    </div>
  );
}
function Th({ children, className = "" }) { return <th className={`text-left font-medium px-3 py-2 ${className}`}>{children}</th>; }
function Td({ children, className = "" }) { return <td className={`px-3 py-2 ${className}`}>{children}</td>; }
